import React, { useState, useEffect } from 'react';
import { api } from '../utils/api';
import { ExternalLink } from 'lucide-react';

const PartnersSection = () => {
  const [partners, setPartners] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchPartners();
  }, []);

  const fetchPartners = async () => {
    try {
      const data = await api.getActivePartners();
      setPartners(data.partners || []);
    } catch (err) {
      console.error('Error fetching partners:', err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex justify-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  if (partners.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Nos Partenaires
          </h2>
          <p className="text-lg text-gray-600">
            Ils nous font confiance
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-8 items-center">
          {partners.map((partner) => (
            <div
              key={partner.id}
              className="flex flex-col items-center justify-center p-4 hover:scale-105 transition-transform"
            >
              {partner.external_link ? (
                <a
                  href={partner.external_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group text-center"
                >
                  {partner.image_url && (
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}${partner.image_url}`}
                      alt={partner.legend}
                      className="h-16 w-auto object-contain grayscale group-hover:grayscale-0 transition-all mb-2"
                    />
                  )}
                  <p className="text-sm text-gray-600 group-hover:text-green-600 transition-colors">
                    {partner.legend}
                  </p>
                </a>
              ) : (
                <div className="text-center">
                  {partner.image_url && (
                    <img
                      src={`${process.env.REACT_APP_BACKEND_URL}${partner.image_url}`}
                      alt={partner.legend}
                      className="h-16 w-auto object-contain grayscale hover:grayscale-0 transition-all mb-2"
                    />
                  )}
                  <p className="text-sm text-gray-600">{partner.legend}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PartnersSection;
